module.exports = __webpack_public_path__ + "img/cat.0405d780.png";